import React from 'react';
import { MiniPanel } from '@cgn/framework-ui-components/v2';

export default function AvvisoEvasionePrioritariaNonDisponibile() {
  return (
    <MiniPanel
      position="right"
      type="warning"
      message={(
        <>
          <p className="modaleQuesito__paragrofo_info">L&apos;evasione prioritaria dei quesiti non è disponibile perché il tuo</p>
          <p className="modaleQuesito__paragrofo_info">piano Eccellenza è sospeso a causa di mancati pagamenti.</p>
          <p className="modaleQuesito__paragrofo_info">Ti abbiamo inviato una mail con maggiori informazioni.</p>
        </>
      )}
    />
  );
}
